import get from 'lodash/get';
import Auth from '../../libs/Auth';

const user = Auth.getPayload() || {};

const initialState = {
  ...user,
};

export default function (state = initialState, action) {
  // todo: I think I should only handle specific actions in here so I know the error originated while trying to login
  // Handle Errors
  if (action.error) {
    switch (action.payload.name) {
      case 'HttpNotAuthorizedError':
      case 'NotAuthorizedError':
      case 'HttpForbiddenError':
      case 'ForbiddenError':
        return {
          ...state,
          errorMessage: get(action.payload, 'data.errors[0].message') || action.payload.message,
        };
      default:
        return state;
    }
  }
  if (action.type === 'ROUTE') {
    // handle leaving page
    if (action.payload.prevPage === 'login') {
      return {
        ...state,
        errorMessage: ''
      };
    }
  }
  switch (action.type) {
    case 'SUBMIT_LOGIN': {
      return {
        ...state,
        token: '',
        errorMessage: ''
      };
    }
    case 'SUBMITTED_LOGIN': {
      return {
        ...state,
        username: action.payload.username,
        email: action.payload.email,
        token: action.payload.token,
        type: action.payload.type,
        errorMessage: ''
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/state/reducers/auth.reducer.js